import styled from "styled-components";

const CustomLabelHeading = styled.div`
  color: var(--elementDim);
  font-size: 30px;
  font-weight: 900;
  text-transform: capitalize;
`;

export default CustomLabelHeading;
